import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum SnackwisePickTicketLineItemKeys {
  itemCode = 'itemCode',
  itemDescription = 'itemDescription',
  itemQty = 'itemQty',
  pickZone = 'pickZone',
  unitPrice = 'unitPrice',
  totalPrice = 'totalPrice',
}

export const snackwisePickTicketFileDataSchema = yup.object().shape({
  pickTicketTitle: yup.string().nullable().optional(),
  pickTicketId: yup.string().nullable().optional(),
  poNumber: yup.string().nullable().optional(),
  date: yup.string().nullable().optional(),
  actionTime: yup.string().nullable().optional(),
  orderRemarks: yup.string().nullable().optional(),
  destination: yup.object().shape({
    attn: yup.string().nullable().optional(),
    externalId: yup.string().nullable().optional(),
    city: yup.string().nullable().optional(),
    zipCode: yup.string().nullable().optional(),
    country: yup.string().nullable().optional(),
  }),
  items: yup
    .array()
    .of(
      yup.object().shape({
        itemCode: yup.string().nullable().optional(),
        itemDescription: yup.string().nullable().optional(),
        itemQty: yup.string().nullable().optional(),
        pickZone: yup.string().nullable().optional(),
        unitPrice: yup.string().nullable().optional(),
        totalPrice: yup.string().nullable().optional(),
      }),
    )
    .required(),
  orderTotal: yup.string().nullable().optional(),
})

export type SnackwisePickTicketFileData = yup.InferType<typeof snackwisePickTicketFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<SnackwisePickTicketFileData>

export const snackwisePickTicketFileMappings: RequiredFileData = {
  pickTicketTitle: '9c3a7657-8b60-4f16-bc73-55b3b3f1c8d7',
  pickTicketId: '4b67a8f1-8b98-4f91-98db-0d68417675cb',
  poNumber: 'c1d3e8a9-0e4f-4c2f-8731-9c998aeac1ef',
  date: '2f1c6a0a-7b64-4b84-bb5f-2b1c4e8b9e56',
  actionTime: 'd94fd1c4-c3a3-4a68-9a8e-c9ea04a5cbd7',
  orderRemarks: '9a174d72-0a70-49c2-bf0c-9e71f88b6b23',
  destination: {
    attn: 'e6a1f6d3-3f7a-44b8-bfb4-ec0f843a8e12',
    externalId: 'fb89c4fa-2b0c-4de2-90a6-3a9cb582b1ec',
    city: '1c44bc96-93ae-4e12-a27b-e918b0dcbb38',
    zipCode: 'c5d6d5dc-70ed-46d5-926e-f7258caa64f4',
    country: '7e632735-43de-4dc4-9359-3cfdfd52a7cf',
  },
  items: [
    {
      itemCode: 'fa8d3c71-1b29-48ea-91f1-3e96e9b384b4',
      itemDescription: '4c3d48b6-8be1-47e3-a234-3e1ec4dbb24f',
      itemQty: '871f3a4c-53f7-4962-b41c-c725d62bcde4',
      pickZone: 'b1a013c5-d58f-4d16-8e1e-5df39e4ac3f1',
      unitPrice: 'f8d66d5c-0bc7-4297-bc2e-34db1e71a9c4',
      totalPrice: '2a1fc5e4-bd15-40a3-879b-6f9b6f32a952',
    },
  ],
  orderTotal: '3d2732cf-1ea0-4e4e-a95c-e4642bbcd609',
}
